import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ShipmentTransportOrderStatusHistoryFacade } from './shipment-transport-order-status-history.facade';
import { TransportOrderIdView } from '../../../../models';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ShipmentTransportOrderItemFacade } from '../shipment-transport-order-item.facade';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderStatusHistoryGuard {
  constructor(
    private shipmentTransportOrderStatusHistoryFacade: ShipmentTransportOrderStatusHistoryFacade,
    private shipmentTransportOrderItemFacade: ShipmentTransportOrderItemFacade,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.shipmentTransportOrderItemFacade.shipmentTransportOrderIdentifier$.pipe(
      switchMap((identifier: TransportOrderIdView) => {
        this.shipmentTransportOrderItemFacade.loadShipmentTransportOrderNotificationListCount(identifier);

        return loadStoreState(this.shipmentTransportOrderStatusHistoryFacade, identifier);
      }),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentTransportOrderStatusHistoryFacade);
  }
}
